import type { DebugToolSettings, DebugTools } from './debugToolTypes';

export enum DebugToolActionTypes {
    UPDATE = 'DEBUG_TOOL_UPDATE',
    RESET = 'DEBUG_TOOL_RESET',
}

export type DebugToolUpdate = {
    [ToolName in DebugTools]: {
        toolName: ToolName;
    } & Omit<DebugToolSettings[ToolName], 'lastUpdateTimestamp'>;
}[DebugTools];

export type DebugToolUpdateAction = DebugToolUpdate & {
    user?: unknown;
    type: DebugToolActionTypes.UPDATE;
};

export type DebugToolResetAction = {
    type: DebugToolActionTypes.RESET;
};

export type DebugToolAction = DebugToolUpdateAction | DebugToolResetAction;
